import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3dad71c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "table-responsive p-0" }
const _hoisted_3 = { class: "table table-head-fixed text-pretty" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["title"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 10,
  class: "btn-group mr-1"
}
const _hoisted_14 = {
  key: 0,
  class: "clearfix p-3 border-top"
}
const _hoisted_15 = { class: "pagination pagination-sm m-0 float-left" }
const _hoisted_16 = { class: "pagination pagination-sm m-0 float-right" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 1,
  class: "page-link"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_AppImageHolder = _resolveComponent("AppImageHolder")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.normalizedColumns, (column, index) => {
              return (_openBlock(), _createElementBlock("th", {
                key: index,
                class: _normalizeClass(column.headerClasses),
                style: _normalizeStyle(column.headerStyles)
              }, [
                _createTextVNode(_toDisplayString(column.label) + " ", 1),
                (column.tooltip)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_4, [
                      _createElementVNode("i", {
                        class: "fas fa-question-circle",
                        title: column.tooltip,
                        "data-toggle": "tooltip"
                      }, null, 8, _hoisted_5)
                    ]))
                  : _createCommentVNode("", true)
              ], 6))
            }), 128))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, rowIndex) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: rowIndex,
              onClick: ($event: any) => (_ctx.emitRowClicked(row))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.normalizedColumns, (column, columnIndex) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: columnIndex,
                  class: _normalizeClass(column.columnClasses),
                  style: _normalizeStyle(_ctx.getColumnStyles(column, row))
                }, [
                  (column.type === _ctx.TableColumnType.Index)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.offset + rowIndex + 1), 1))
                    : (column.type === _ctx.TableColumnType.Text)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.getCellValue(row, column.key)), 1))
                      : (column.type === _ctx.TableColumnType.DateTime)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.formatDateValue(_ctx.getCellValue(row, column.key))), 1))
                        : (column.type === _ctx.TableColumnType.Slot)
                          ? _renderSlot(_ctx.$slots, column.slotName, {
                              key: 3,
                              value: row
                            }, undefined, true)
                          : (column.type === _ctx.TableColumnType.Html)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 4,
                                innerHTML: column.htmlHandler(row)
                              }, null, 8, _hoisted_10))
                            : (column.type === _ctx.TableColumnType.Option)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 5,
                                  innerHTML: _ctx.renderOption(column.options, _ctx.getCellValue(row, column.key))
                                }, null, 8, _hoisted_11))
                              : (column.type === _ctx.TableColumnType.Boolean)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 6,
                                    innerHTML: _ctx.renderOption(_ctx.booleanOption, _ctx.getCellValue(row, column.key))
                                  }, null, 8, _hoisted_12))
                                : (column.type === _ctx.TableColumnType.RouterLink)
                                  ? (_openBlock(), _createBlock(_component_RouterLink, {
                                      key: 7,
                                      to: column.to(row)
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(column?.content?.(row) ?? _ctx.getCellValue(row, column.key)), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]))
                                  : (column.type === _ctx.TableColumnType.Image)
                                    ? (_openBlock(), _createBlock(_component_AppImageHolder, {
                                        key: 8,
                                        image: _ctx.getCellValue(row, column.imageKey) as string,
                                        status: column.statusKey ? _ctx.getCellValue(row, column.statusKey) as number : null
                                      }, null, 8, ["image", "status"]))
                                    : (column.type === _ctx.TableColumnType.Component)
                                      ? (_openBlock(), _createBlock(_resolveDynamicComponent(column.component), _normalizeProps(_mergeProps({ key: 9 }, column.propsHandler?.(row))), {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(column.contentHandler?.(row)), 1)
                                          ]),
                                          _: 2
                                        }, 1040))
                                      : (column.type === _ctx.TableColumnType.Actions && _ctx.actions.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resolveTableActions(_ctx.actions, row), (actionProps, actionIndex) => {
                                              return (_openBlock(), _createBlock(_component_AppButton, _mergeProps({ key: actionIndex }, actionProps), null, 16))
                                            }), 128))
                                          ]))
                                        : _createCommentVNode("", true)
                ], 6))
              }), 128))
            ], 8, _hoisted_6))
          }), 128))
        ])
      ])
    ]),
    (_ctx.pagination.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("ul", _hoisted_15, _toDisplayString(_ctx.paginationSummary), 1),
          _createElementVNode("ul", _hoisted_16, [
            _createElementVNode("li", {
              class: _normalizeClass(["paginate_button page-item previous", _ctx.previousPageClass])
            }, [
              _createElementVNode("a", {
                class: "page-link",
                href: "#",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.movePage(_ctx.currentPage - 1)), ["prevent"]))
              }, "Prev")
            ], 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagination, (page) => {
              return (_openBlock(), _createElementBlock("li", {
                key: page,
                class: _normalizeClass(["paginate_button page-item", _ctx.getPageClass(page)])
              }, [
                (typeof page === 'number')
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "page-link",
                      href: "#",
                      onClick: _withModifiers(($event: any) => (_ctx.movePage(page)), ["prevent"])
                    }, _toDisplayString(page), 9, _hoisted_17))
                  : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(page), 1))
              ], 2))
            }), 128)),
            _createElementVNode("li", {
              class: _normalizeClass(["paginate_button page-item next", _ctx.nextPageClass])
            }, [
              _createElementVNode("a", {
                class: "page-link",
                href: "#",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.movePage(_ctx.currentPage + 1)), ["prevent"]))
              }, "Next")
            ], 2)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}